'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { Icon } from '@/components/ui/icon';
import { UserIcon } from '@/components/ui/icon/glyphs';
import { useAuthGate } from '@/hooks/use-auth-gate';
export function UnauthenticatedPrompt() {
  const $ = _c(22);
  const t = useTranslations("profile");
  const tHeader = useTranslations("header");
  const {
    openLogin
  } = useAuthGate();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex size-16 items-center justify-center rounded-full bg-background-tertiary"><Icon icon={UserIcon} className="size-8 text-foreground-secondary" aria-hidden={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h1 className="text-heading">{t1}</h1>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("not_authenticated");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="max-w-sm text-body text-foreground-secondary">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex flex-col items-center gap-2 text-center">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== openLogin) {
    t6 = () => {
      openLogin();
    };
    $[12] = openLogin;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== tHeader) {
    t7 = tHeader("connect");
    $[14] = tHeader;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <AnimatedButton onClick={t6} className="min-h-11 min-w-40">{t7}</AnimatedButton>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = <main className="flex min-h-[60dvh] flex-col items-center justify-center gap-6 px-4 py-12">{t0}{t5}{t8}</main>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}